export default __webpack_public_path__ + "static/media/arrow-dropdown.e564fed3.svg";